import { Component, Prop, Vue } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';
import moment from 'moment';
// tslint:disable-next-line: no-var-requires
const Datepicker = require('@hokify/vuejs-datepicker').default;

@Component({
  components: {
    Datepicker,
  },
})
export default class InputDate extends InputBase<Date> {
  @Prop({ default: '' }) public min?: string;
  @Prop({ default: '' }) public max?: string;
  @Prop({ default: true }) public typeable?: boolean;
  @Prop({ default: false }) public clearButton?: boolean;
  @Prop({ default: false }) public calendarButton?: boolean;
  public formatter = 'DD.MM.YYYY';
  public componentKey = 0;

  private get lang() {
    return this.$i18n.locale;
  }
  private get disabledDates() {
    return {
      to: this.min ? new Date(moment(this.min).format('YYYY-MM-DD')) : '',
      from: this.max ? new Date(moment(this.max).format('YYYY-MM-DD')) : '',
    };
  }

  /**
   * Emit the date value as a new Date object in order to reset the timezone
   * @param date The input date given by the Datepicker component
   */
  protected updateValue(date: any) {
    if (date) {
      this.$emit('input', new Date(moment(date).format('YYYY-MM-DD')));
    } else {
      this.$emit('input', date);
    }
  }

  /**
   * Format the date to display to the end-user
   * @param date The date value to format
   */
  protected customFormatter(date: any) {
    return moment(date).format('DD.MM.YYYY');
  }
  
  /**
   * Au moment ou le datepicker se ferme, on recharge l'élément ce qui
   * permet d'avoir le bon visuel de la date et non pas juste ce que l'utilisateur
   * a entré manuellement
   * @date 03.08.2023 - 10:10:44
   */
  closed(){
    this.componentKey += 1;
  }

  /**
   * Initializes the component
   */
  protected mounted() {
    this.setInputMode();
  }

  /**
   * Sets inputmode="numeric" on the datepicker input for mobile keyboard
   */
  private setInputMode() {
    this.$nextTick(() => {
      const input = this.$el.querySelector('input');
      if (input) {
        input.setAttribute('inputmode', 'numeric');
      }
    });
  }
}
